<template>
    <div id="wrapper" class="full-background">
        <div class="recover-link">
            <div class="d-flex align-items-center flex-wrap w-100 justify-content-between">
                <div class="ln_forlang mb-1 mr-1">
                    <div class="langs">
                        <a :class="{selected: language==='uz'}" @click="changeLang('uz')">
                            UZ
                        </a>
                        <a :class="{selected: language==='ru'}" @click="changeLang('ru')">
                            RU
                        </a>
                        <a :class="{selected: language==='en'}" @click="changeLang('en')">
                            EN
                        </a>
                    </div>
                </div>
                <button
                    class="btn-sm mb-1"
                    type="button"
                    style="background-color: #fff"
                    data-toggle="modal"
                    data-target="#recoveryModal"
                    @click="openModal"
                >
                    {{i18n('Ticket Recovery')}}
                </button>
            </div>
        </div>
        <div class="dis-table">
            <div class="table-cell">
                <div class="container">
                    <div class="page-title">
                        <h1>
                            {{i18n('Sale tickets at the price of a bus station')}}
                        </h1>
                    </div>
                    <div class="border-box">
                        <form class="form-row">
                            <div class="col-lg-3 col-md-6">
                                <button class="btn inline-item btn-to" type="button" disabled :class="{'has-error': from.error}">
                                    <span class="placeholder" v-if="!from.name">{{ i18n('Tashkent')}}</span>
                                    <span v-else>{{from.name}}</span>
                                </button>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <button class="btn inline-item btn-to" type="button" data-toggle="modal" data-target="#cityModal" :class="{'has-error': to.error}">
                                    <span class="placeholder" v-if="!to.name">{{ i18n('Where to')}}</span>
                                    <span v-else>{{to.name}}</span>
                                </button>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <button type="button" data-toggle="modal" data-target="#whereModal" class="btn inline-item btn-where" :class="{'has-error': date.error}">
                                    <span class="placeholder" v-if="!date.date">{{ i18n('When')}}</span>
                                    <span v-else>{{date.date}}</span>
                                    <img src="/img/icon03.svg" alt=""/>
                                </button>
                            </div>
                            <div class="col-lg-3 col-md-6 text-center">
                                <button type="button" class="btn btn-primary btn-next" :disabled="disableButton" @click="next">
                                    {{i18n('Next')}}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="recoveryModal" tabindex="-1" role="dialog" aria-labelledby="recoveryModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="d-flex">
                            <button v-if="step > 1" @click="back" class="btnback">
                                <img src="/img/icon01.svg" alt=""/>
                            </button>
                            <div>
                                {{i18n('Ticket Recovery')}}
                            </div>
                        </div>
                    </div>
                    <div class="modal-body" v-if="step === 1">
                        <label>
                            {{i18n('Enter phone number')}}
                        </label>
                        <phone-number v-model="userPhone" :on-enter="sendSmsCode"></phone-number>
                        <button class="btn btn-primary" @click="sendSmsCode" :disabled="userPhone < 900000000 || is_loading">
                            <div v-if="is_loading" class="lds-ripple">
                                <div></div>
                                <div></div>
                            </div>
                            <span v-else>
                                {{i18n('Submit Code')}}
                            </span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="step === 2">
                        <label>
                            {{i18n('Enter phone number')}}
                        </label>
                        <phone-number v-model="userPhone" :disabled="1"></phone-number>
                        <label for="codeinput">Код</label>
                        <input autocomplete="off" id="codeinput" v-model.number="userCode" @keypress.enter="getTicketsByPhoneNumber" class="form-control num">
                        <br>
                        <button class="btn btn-primary" @click="getTicketsByPhoneNumber" :disabled="userCode.length < 6 || is_loading">
                            <div v-if="is_loading" class="lds-ripple">
                                <div></div>
                                <div></div>
                            </div>
                            <span v-else>
                                 {{i18n('Get my tickets')}}
                            </span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="step === 3">

                        <table class="tct">
                            <thead>
                            <tr>
                                <th scope="col">
                                    {{i18n('Data')}}
                                </th>
                                <th scope="col">
                                    {{i18n('Reys')}}
                                </th>
                                <th scope="col">
                                    {{i18n('Name')}}
                                </th>
                                <th scope="col">
                                    {{i18n('Ticket')}}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="ticket in tickets">
                                <td data-label="Дата">{{ ticket.created_at }}</td>
                                <td data-label="Рейс">{{ ticket.route_name }}</td>
                                <td data-label="Имя">{{ ticket.full_name }}</td>
                                <td data-label="Билет">
                                    <a :href="ticket.image" target="_blank">
                                        <img class="qrticket" :src="ticket.qr" alt="ticket"/>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-show="tickets.length === 0" class="text-center pt-3 pb-3 border">
                            {{i18n('No tickets')}}.
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!-- City Modal -->
        <div class="modal fade" id="cityModal" tabindex="-1" role="dialog" aria-labelledby="cityModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row" v-if="!showStations">
                            <div class="col-sm-4" v-for="location in locations">
                                <a href="javascript:void(0);" @click="getStations(location)">{{location.name}}</a>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-sm-4" v-for="station in stations">
                                <a href="javascript:void(0);" :class="{selected: station.id === to.id}" @click="getStation(station)">{{station.name}}</a>
                            </div>
                            <div v-if="stations.length === 0">
                                <h3> {{i18n('There is no train station in this location yet')}}</h3>
                            </div>
                        </div>
                        <div class="row" v-if="showStations">
                            <a href="javascript:void(0)" @click="toLocations" class="backlink">{{i18n('Back')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="copyright">
            © 2019 {{i18n('Ministry of Transport of the Republic of Uzbekistan')}}.
            {{i18n('All rights reserved')}}.
            {{i18n('Portal developed')}} <b><a href="https://igenius.uz/" target="_blank">Genesis Innovation</a></b> <i style="font-size: 9px">(v{{ app_version }})</i>
        </div>

        <!-- Where Modal -->
        <div class="modal fade" id="whereModal" tabindex="-1" role="dialog" aria-labelledby="whereModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="datepicker"></div>
                    </div>
                </div>
            </div>
        </div>
        <div id="nyd2020">
            <img src="/images/2020.png" alt="2020">
        </div>
    </div>
</template>
<script>
    import PhoneNumber from "../../js/components/PhoneNumber";
    export default {
        name: "Main",
        components: {PhoneNumber},
        data() {
            return {
                from: {
                    error: false,
                    id: null,
                    name: null
                },
                to: {
                    error: false,
                    id: null,
                    name: null
                },
                date: {
                    error: false,
                    date: null
                },
                locations: [],
                stations: [],
                showStations: false,
                disableButton: true,
                userPhone: '',
                userCode: '',
                code_sent: false,
                step: 1,
                tickets: [],
                is_loading: false
            }
        },
        created() {
            this.$store.commit('setId', new DeviceUUID().get());
            this.from = this.$store.state.from;
            this.to = this.$store.state.to;
            this.date = this.$store.state.date;
            this.$store.state.isMain = true;
            this.$moment.locale('ru');
            this.checkStatus();
            this.getLocation();
        },
        mounted() {
            $('.datepicker').datepicker({
                language: 'ru',
                startDate: new Date()
            }).on('changeDate', (e) => {
                this.date.error = false;
                this.date.date = this.$moment(e.date).format('YYYY-MM-DD');
                this.$store.state.date = this.date;
                this.checkStatus();
                $('#whereModal').modal('hide');
            });

        },
        methods: {
            checkStatus() {
                this.disableButton = !this.to.id || !this.date.date;
            },
            getLocation() {
                axios.get('/infokiosk/locations')
                    .then(res => {
                        res.data.data.forEach(item => {
                            if (item.id !== 1 && item.id !== 2) {
                                this.locations.push(item);
                            }
                        });
                    })
            },
            next() {
                if (!this.from.id) {
                    this.from.error = true;
                }
                if (!this.to.id) {
                    this.to.error = true;
                }
                if (!this.date.date) {
                    this.date.error = true;
                }
                if (this.from.error === false && this.to.error === false && this.date.error === false) {
                    localStorage.setItem('searchFrom', JSON.stringify(this.$store.state.from));
                    localStorage.setItem('searchTo', JSON.stringify(this.$store.state.to));
                    localStorage.setItem('searchDate', JSON.stringify(this.$store.state.date));
                    this.$router.push({
                        name: 'web-trips', params: {
                            'from': this.$store.state.from.id,
                            'to': this.$store.state.to.id,
                            'date': this.$store.state.date.date,
                        }
                    });
                }
            },
            getStations(location) {
                this.stations = location.stations;
                this.showStations = true;
            },
            toLocations() {
                this.showStations = false;
            },
            getStation(station) {
                this.to.name = station.name;
                this.to.id = station.id;
                this.to.error = false;
                this.$store.state.to = this.to;
                this.checkStatus();
                $('#cityModal').modal('hide');
                // this.showStations = false;
            },
            openModal() {
                // if (!(this.step === 1 || this.step === 2)) {
                //     this.step = 1;
                // }
            },
            getTicketsByPhoneNumber() {
                if (this.is_loading === false && this.userCode.toString().length === 6) {
                    this.is_loading = true;
                    this.$http.post('infokiosk/get-tickets-by-number', {number: this.userPhone, code: this.userCode}).then(({data}) => {
                        if (data.data.success) {
                            this.tickets = data.data.tickets;
                            this.step = 3;
                        } else {
                            this.tickets = [];
                        }
                    }).catch(err => {
                    }).finally(() => {
                        this.is_loading = false;
                    });
                }
            },
            sendSmsCode() {
                if (this.is_loading === false && this.userPhone > 900000000) {
                    this.is_loading = true;
                    this.$http.post('infokiosk/send-sms-code', {number: this.userPhone}).then(({data}) => {
                        if (data.data.success) {
                            this.step = 2;
                        }
                    }).catch(err => {
                    }).finally(() => {
                        this.userCode = '';
                        this.is_loading = false;
                    });
                }
            },
            back() {
                if (this.step === 3) {
                    this.step = 1;
                    this.userPhone = '';
                    this.userCode = '';
                } else {
                    this.step--;
                }
            },

            changeLang(lang) {
                this.$store.commit('changeCurrentLanguage', lang);
            }
        },
        computed: {
            language() {
                return this.$store.state.currentLang;
            },

            app_version: () => window.__APP__VERSION__,
        },
        watch: {
            userCode(n) {
                if (typeof n !== 'number') {
                    let nn = parseInt(n.replace(/[^0-9.]/g, "").substr(0, 6));
                    this.userCode = isNaN(nn) ? '' : nn;
                } else if (n > 999999) {
                    this.userCode = parseInt(n.toString().substr(0, 6));
                }
            },
        },
        beforeRouteLeave(to, from, next) {
            this.$store.state.isMain = false;
            next();
        }
    }
</script>

<style>
    #nyd2020 {
        position: fixed;
        top: 40px;
        left: 0;
        right: 0;
        z-index: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30vw;
        margin: auto;
        height: 40vh;
    }
    #nyd2020 img {
        max-width: 100%;
        max-height: 100%;
    }
    @media (max-width: 992px) {
        #nyd2020 {
            display: none;
        }
    }
    .recover-link {
        position: absolute;
        left: 15px;
        right: 15px;
        top: 15px;
    }
    .full-background .page-title{
        padding-top: 50px;
    }
    .ln_forlang {
        width: 140px;
        background-color: #fff;
        padding: 6px;
        border-radius: 4px;
    }
    .ln_forlang .langs{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .ln_forlang .langs a {
        display: flex;
        width: 25%;
        min-height: 20px;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        font-size: 14px;
    }

    @media only screen and (max-width: 767px) {
        .scrollable-table-seats {
            overflow: scroll;
        }
    }

    button {
        border: 2px solid transparent;
        display: flex;
        align-items: center;
    }

    button span {
        line-height: 1;
    }

    button.has-error {
        border: 2px solid #dc3545 !important;
    }

    button.has-error span {
        color: #dc3545 !important;
    }

    .selected {
        color: #0094ff !important;
        font-weight: bold;
    }

    .btn-next {
        justify-content: center;
    }

    .btn-back > img {
        margin-left: 10px;
    }

    .backlink {
        margin: 8px;
        background-color: #EFF3F6;
        padding: 8px 32px;
        border-radius: 6px;
    }

    .inline-item.btn-to > span {
        max-width: 172px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden !important;
        max-lines: 2;
    }

    @media (min-width: 1200px) {
        .inline-item.btn-to > span {
            max-width: 180px;
        }
    }

    .datepicker table tr td.disabled, .datepicker table tr td.disabled:hover {
        background: #dedede;
        border-radius: 0;
    }


    table.tct {
        margin: -1rem;
        border: 1px solid #ccc;
        border-collapse: collapse;
        padding: 0;
        width: calc(100% + 2rem);
        table-layout: fixed;
    }

    table.tct caption {
        font-size: 1.5em;
        margin: .5em 0 .75em;
    }

    table.tct tr {
        background-color: #fefefe;
        border: 1px solid #ddd;
        padding: .35em;
    }

    table.tct th,
    table.tct td {
        padding: .625em;
        text-align: center;
    }

    table.tct th {
        font-size: .85em;
        letter-spacing: .1em;
        text-transform: uppercase;
    }

    @media screen and (max-width: 600px) {
        table.tct {
            border: 0;
        }

        table.tct caption {
            font-size: 1.3em;
        }

        table.tct thead {
            border: none;
            clip: rect(0 0 0 0);
            height: 1px;
            margin: -1px;
            overflow: hidden;
            padding: 0;
            position: absolute;
            width: 1px;
        }

        table.tct tr {
            border-bottom: 3px solid #ddd;
            display: block;
            margin-bottom: .625em;
        }

        table.tct td {
            border-bottom: 1px solid #ddd;
            display: block;
            font-size: .8em;
            text-align: right;
        }

        table.tct td::before {
            content: attr(data-label);
            float: left;
            font-weight: bold;
            text-transform: uppercase;
        }

        table.tct td:last-child {
            border-bottom: 0;
        }
    }

    .btnback {
        background: #fff;
        margin-right: 16px;
        padding: 4px;
        width: 36px;
    }

    .btnback img {
        width: 100%;
    }

    .qrticket {
        width: 64px;
        height: 64px;
    }

    .copyright {
        color: #EEEEEE;
        text-align: center;
        font-size: 14px;
    }
</style>
